import {
  FORBIDDEN_TEXT,
  getErrorStatus,
  getForbiddenReason,
  SERVICE_UNAVAILABLE_TEXT,
} from '../../../common/api/errors'

/** Text of a refused sign-in; the sign-in shows it itself (the common alerts stay out of the login requests). */
export const loginErrorText = (error: unknown): string => {
  const status = getErrorStatus(error)

  if (status === 401 || status === 400) {
    return 'Неверный логин или пароль.'
  }
  if (status === 429) {
    return 'Превышено допустимое количество попыток. Пожалуйста, попробуйте снова позже.'
  }
  if (status === 403) {
    return getForbiddenReason(error) ?? FORBIDDEN_TEXT
  }
  if (status === 503) {
    return SERVICE_UNAVAILABLE_TEXT
  }
  if (error instanceof Error && error.message) {
    return error.message
  }

  return 'Что-то пошло не так.'
}
